/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProfileBotMappingDto } from '../models/profile-bot-mapping-dto';

@Injectable({
  providedIn: 'root',
})
export class ProfileBotMappingControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }
  /**
   * Path part for operation saveProfileBotMapDetails
   */
  static readonly SaveProfileBotMapDetailsPath = '/api/v1/profile/{profileId}/chat-bot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveProfileBotMapDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveProfileBotMapDetails$Response(params: {
    profileId: string;
    body?: ProfileBotMappingDto
  }
): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileBotMappingControllerService.SaveProfileBotMapDetailsPath, 'post');
    if (params) {
      rb.path('profileId', params.profileId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveProfileBotMapDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveProfileBotMapDetails(params: {
    profileId: string;
    body?: ProfileBotMappingDto
  }
): Observable<string> {

    return this.saveProfileBotMapDetails$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getBotDetailsByProfile
   */
  static readonly GetBotDetailsByProfilePath = '/api/v1/profile/{profileId}/chat-bot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBotDetailsByProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBotDetailsByProfile$Response(params: {
    profileId: string;
  }
): Observable<StrictHttpResponse<Array<ProfileBotMappingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileBotMappingControllerService.GetBotDetailsByProfilePath, 'get');
    if (params) {
      rb.path('profileId', params.profileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProfileBotMappingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getBotDetailsByProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBotDetailsByProfile(params: {
    profileId: string;
  }
): Observable<Array<ProfileBotMappingDto>> {

    return this.getBotDetailsByProfile$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProfileBotMappingDto>>) => r.body as Array<ProfileBotMappingDto>)
    );
  }

}
